module.exports = new __parcel__URL__("nl_3.d58cedc9.png").toString();